// import React from 'react'; // Removed unused import
import './UserProfile.css';

const UserProfile = ({ user, onBack }) => {
  const categories = [
    { id: 'yourpost', name: 'X(Twitter)+retweet', dbFields: ['retweet', 'twitter'] },
    { id: 'comment', name: 'Comment', dbFields: ['comment'] },
    { id: 'cmc', name: 'CoinMarketCap', dbFields: ['cmc'] }
  ];

  const getTotalXPForCategory = (categoryId) => {
    const category = categories.find(cat => cat.id === categoryId);
    if (!category) return 0;
    
    return category.dbFields.reduce((total, field) => {
      return total + (user[field]?.xp || 0);
    }, 0);
  };

  const getSubmissionsForCategory = (categoryId) => {
    const category = categories.find(cat => cat.id === categoryId);
    if (!category) return 0;
    
    return category.dbFields.reduce((total, field) => {
      return total + (user[field]?.submissions || 0);
    }, 0);
  };

  // const getTotalXP = () => {
  //   return categories.reduce((total, category) => {
  //     return total + getTotalXPForCategory(category.id);
  //   }, 0);
  // };

  // const getTotalSubmissions = () => {
  //   return categories.reduce((total, category) => {
  //     return total + getSubmissionsForCategory(category.id);
  //   }, 0);
  // };

  return (
    <div className="user-profile-container">
      <div className="profile-header">
        <button className="back-btn" onClick={onBack}>
          ← Back to Leaderboard
        </button>
        <h2 className="username">{user.username}</h2>
        <div className="total-stats">
          <div className="stat">
            <span className="stat-value">{user.submission_xp || user.submissionsXP || 0}</span>
            <span className="stat-label">Submissions XP</span>
          </div>
          <div className="stat">
            <span className="stat-value">{(user.referral_xp || 0).toFixed(1)}</span>
            <span className="stat-label">Referral XP</span>
          </div>
          <div className="stat">
            <span className="stat-value">{(user.bonus_xp || 0)}</span>
            <span className="stat-label">Bonus XP</span>
          </div>
          <div className="stat">
            <span className="stat-value">{(user.total_xp || 0)}</span>
            <span className="stat-label">Total XP</span>
          </div>
          <div className="stat">
            <span className="stat-value">{user.submissions_count || 0}</span>
            <span className="stat-label">Total Submissions</span>
          </div>
        </div>
      </div>

      <div className="category-breakdown">
        <h3>Category Breakdown</h3>
        <div className="categories-grid">
          {categories.map(category => (
            <div key={category.id} className="category-card">
              <h4 className="category-name">{category.name}</h4>
              <div className="category-stats">
                <div className="stat">
                  <span className="stat-value">{getTotalXPForCategory(category.id)}</span>
                  <span className="stat-label">XP</span>
                </div>
                <div className="stat">
                  <span className="stat-value">{getSubmissionsForCategory(category.id)}</span>
                  <span className="stat-label">Submissions</span>
                </div>
              </div>
              {/* <div className="subcategories">
                {category.dbFields.map(field => (
                  <div key={field} className="subcategory">
                    <span className="subcategory-name">{formatFieldName(field)}</span>
                    <span className="subcategory-xp">{user[field]?.xp || 0} XP</span>
                  </div>
                ))}
              </div> */}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

// const formatFieldName = (fieldName) => {
//   const fieldDisplayNames = {
//     retweet: 'Retweet',
//     twitter: 'Twitter Post',
//     comment: 'Comment',
//     youtube: 'YouTube'
//   };
//   return fieldDisplayNames[fieldName] || fieldName;
// };

export default UserProfile;